import { useModals } from 'almanac-ui/Modal'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { ReviewSummaryDrawer } from 'components/ReviewSummaryModal/ReviewSummaryDrawer'
import { ReviewSummaryModal } from 'components/ReviewSummaryModal/ReviewSummaryModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import useResponsiveFunction from 'hooks/useResponsiveFunction'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

interface Props {
  request?: InformalFeedbackRequest
}

export const ViewSummaryButton = observer(({ request, ...props }: Props & ButtonProps) => {
  const { openModal, closeAllModals } = useModals()
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()

  const openReviewSummary = useResponsiveFunction({
    mobileFunction: () => {
      if (!request) return

      drawersStore.closeAllDrawers()
      drawersStore.openDrawer(ReviewSummaryDrawer, { request })
    },
    defaultFunction: () => {
      if (!request) return

      closeAllModals()
      openModal(ReviewSummaryModal, { requestId: request.id })
    },
  })

  return (
    <Button {...props} size={isMobile ? 'lg' : 'md'} onPress={openReviewSummary}>
      View Summary
    </Button>
  )
})
